import React from 'react';
import { Star } from 'lucide-react';
import GphRichBlock from '../GphRichBlock';
import { getDrillById } from '../../../data/gphDrillCatalog';

// Favoritos por usuário autenticado (persistidos em coleção client-owned do Firestore).
export default function FavoritesSkillAdapter({ agent }) {
  const favorites = agent.favorites.list();

  return (
    <GphRichBlock eyebrow="Favoritos" title="Meus treinos favoritos">
      {favorites.length === 0 ? (
        <div className="gph-empty">
          <p>Você ainda não favoritou nenhum treino. Peça uma jogada e toque em “Favoritar treino”.</p>
          <button
            type="button"
            className="gph-btn gph-btn--primary"
            onClick={() => agent.runCapability('training_single_drill', {})}
          >
            Quero treinar uma jogada
          </button>
        </div>
      ) : (
        <div className="gph-favorites-list">
          {favorites.map((favorite) => {
            const drill = getDrillById(favorite.drillId);
            return (
              <button
                key={favorite.drillId}
                type="button"
                className="gph-favorite-row"
                onClick={() => agent.deliverDrill(favorite.drillId)}
              >
                <Star size={14} className="gph-favorite-row__icon" />
                <span className="gph-favorite-row__title">{drill?.title || favorite.title}</span>
              </button>
            );
          })}
        </div>
      )}
    </GphRichBlock>
  );
}
